export class CreativeWrapper {
    constructor(option, container) {
        const createRenderer = container.resolve(11 /* T.RENDERER_FACTORY */);
        this.renderer_m = createRenderer(option);
        this.animator_m = container.resolve(5 /* T.ANIMATOR */);
        this.feedStore_m = this.renderer_m.feedStore;
    }
}
